<div *ngIf="exibirLoader">
  <app-loader></app-loader>
</div>

<form *ngIf="etapaCadastro !== 5" class="cadastro__form" novalidate [formGroup]="cadastroForm" (submit)="cadastrar()">
  <header class="form__header" *ngIf="etapaCadastro !== 5" [hidden]="etapaCadastro === 7">
    <p class="header__voltar__acesso" (click)="irParaAcesso()">
      <svg class="voltar__icone" width="12" height="20" viewBox="0 0 12 20" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2L2 10L10 18" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      {{ etapaCadastro === 1 ? "Já sou Cacau Lover" : "Voltar" }}
    </p>
    <img src="assets/images/logos/cacaulovers.png" class="lovers__logo" />
    <p id="tituloCadastro" class="header__cadastro">{{ tituloModal() }}</p>
  </header>

  <div class="etapa__0" [hidden]="etapaCadastro !== 1">
    <div class="etapa__0__container">
      <p>Faça parte do programa de apaixonados por chocolate Cacau Show! <br>
        Preencha os dados abaixo e compartilhe momentos feliz hoje.</p>
    </div>
    <div class="etapa__0__container__input">
      <shared-input-lovers id="cpf" controlName="cpf" label="CPF" mask="000.000.000-00" labelError="CPF inválido!"></shared-input-lovers>
      <shared-input-lovers id="nome" controlName="nome" label="Nome completo"></shared-input-lovers>
    </div>
  </div>

  <div class="etapa__0" [hidden]="etapaCadastro !== 2">
    <div class="etapa__0__container">
      <p style="margin-bottom: 16px;">Por favor, informe sua data de nascimento e seus dados de contato.</p>
      <shared-input-lovers
        id="dataNascimento"
        (onBlur)="validarDataNascimento()"
        controlName="dataNascimento"
        label="Data de nascimento"
        mask="00/00/0000">
      </shared-input-lovers>
          <div style="margin-top: 8px;" *ngIf="dataNascimento < 16">
            <p class="mensagem__erro" >Somente maiores de 16 anos podem se cadastrar-se! leia o <a (click)="mostrarPopupRegulamento()"><b>regulamento</b></a>.</p>
          </div>

        <div *ngIf="precisaAprovador">
          <p style="margin-bottom: 16px; margin-top: 16px;">Para continuar, precisamos da aprovação do seu responsável cadastrado no programa.</p>
          <shared-input-lovers
          id="cpfResponsavel"
          [loading]="loading.loadingResponsavel"
          [labelError]="ResponsavelLabelError"
          [labelCampoValidado]="labelResponsavelValidado"
          [habilitaIconeCheck]="aprovadorValido"
          [habilitaIconeErro]="aprovadorValido === false"
          style="margin-top: 16px;"
          (onBlur)="ValidarResponsavel()"
          id="cpf-responsavel" controlName="cpfResponsavel"
          label="CPF do responsável"
          mask="000.000.000-00"></shared-input-lovers>
      </div>
    </div>
  </div>

  <div class="etapa__0" [hidden]="etapaCadastro !== 3">
    <div class="etapa__0__container">
    <div class="etapa__0__container__input">
    <p>Para não perder nenhuma novidade, informe o seu e-mail e seu número de celular.</p>
    <shared-input-lovers
      id="email"
      controlName="email"
      [label]="labelEmail"
      [loading]="loading.loadingEmail"
      [habilitaIconeCheck]="EmailValido"
      (onBlur)="validarEmailDisponivel()"
      (click)="resetEmail()">
    </shared-input-lovers>
    <div class="etapa__0__container__input__tel">
      <shared-input-lovers id="celular" [tab]="-1" iconeEsquerdo="/assets/images/pais/brasil.svg" [disabled]="true" label="+55"
        controlName="ddd"></shared-input-lovers>
      <shared-input-lovers
      [loading]="loading.loadingTelefone"
      [(habilitaIconeCheck)]="telefoneValido"
      controlName="celular"
      label="Celular"
      mask="(00) 00000-0000"
      (click)="resetTelefone()"
      (onBlur)="validarTelefoneDisponivel()"></shared-input-lovers>
    </div>

    </div>
    </div>
  </div>

  <div class="etapa__0" [hidden]="etapaCadastro !== 4">
    <div class="etapa__0__container__input">
      <shared-input-lovers id="senha" type="password" controlName="senha" label="Senha" [exibirSenha]="true"
        (valueChanged)="validatorRegex($event)"></shared-input-lovers>
      <app-validete-password [valuePassword]="cadastroForm.controls['senha'].value" (passwordValidate)="valuePassword($event)"></app-validete-password>
      <shared-input-lovers id="confirmarSenha" type="password" [labelError]="senhaValida ? 'A senha está divergente.' : ''"
        controlName="confirmarSenha" label="Confirmar senha" [exibirSenha]="true"></shared-input-lovers>
    </div>
    <shared-checkbox-lovers labelBranca="true" [labelAceite]="true" style="width: 100%;" labelPrimaria="true" controlName="aceiteTermos"
      (onTermosClick)="mostrarPopupTermos()" (onRegulamentosClick)="mostrarPopupRegulamento()"
      darkMode="true"></shared-checkbox-lovers>
  </div>

  <div class="form__continuar" *ngIf="etapaCadastro !== 5">
    <shared-button-lovers id="continuar" class="proxima__etapa" [loading]="exibirLoader" [label]="etapaCadastro !== 4 ? 'Continuar' : 'Pronto'"
      (click)="irParaEtapa()" [disabled]="verificaEtapa()"></shared-button-lovers>
  </div>

  <div class="form__etapas" [hidden]="etapaCadastro === 5">
    <div class="etapas__etapa" *ngFor="let etapa of etapas; let i = index" [ngClass]="{
        'etapa--atual': etapa === etapaCadastro,
        'etapa--concluida': i < etapaCadastro
      }"></div>
  </div>
</form>

<div *ngIf="etapaCadastro === 5" class="etapa__sucesso">
  <div *ngIf="etapaCadastro === 5" class="etapa__6">
    <img src="assets/images/others/cadastro_lover.gif" class="cadastro__confete" />

    <img class="lovers__image" src="assets/images/others/novo_lover.png" alt="Cadastro Realizado" />

    <div *ngIf="!precisaAprovador">
      <p class="parabens">Parabéns Crush!</p>
      <p class="acesse">
        Agora você pode entrar na sua conta e aproveitar todas as vantagens!
      </p>
    </div>

    <div *ngIf="precisaAprovador">
      <p class="parabens">Parabéns Crush!</p>
      <p class="acesse">
        Aguarde aprovação do seu responsável para entrar na sua conta e aproveitar todas as vantagens!
      </p>
    </div>
    <div class="form__acessar" *ngIf="!precisaAprovador">
      <button class="lovers-button cadastro__entrar__btn" type="button" (click)="acessar()" [disabled]="entrando"
        [ngClass]="{ 'lovers--disabled': entrando }">
        Entrar
        <img *ngIf="!entrando" class="entrar-btn__icon" src="assets/images/icons/seta.png" />
        <i *ngIf="entrando" class="fa fa-spinner fa-spin"></i>
      </button>
    </div>
  </div>
</div>

<lovers-popup [exibir]="exibePopupGenerico" (onClose)="exibePopupGenerico = false" tamanho="grande">
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>
